export var LotteryRowClassEnum;
(function (LotteryRowClassEnum) {
    LotteryRowClassEnum["Shard"] = "award-shard";
    LotteryRowClassEnum["Ticket"] = "award-ticket";
    LotteryRowClassEnum["Currency"] = "award-currency";
    LotteryRowClassEnum["Money"] = "award-gold";
})(LotteryRowClassEnum || (LotteryRowClassEnum = {}));
